module.exports = __webpack_public_path__ + "fonts/notosans-bold-web.13a0c35.woff";